let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("Okwbl")).then(() => parcelRequire('5ac1R'));